module.exports = __webpack_public_path__ + "static/img/qr_bilibili.598ae56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/focus/qr_bilibili.png
// module id = 0sD5
// module chunks = 6